import { combineEpics } from 'redux-observable'

import { extractErrorMessage, isError } from 'utils/ErrorMessages'

import accountInvestigationEpic from 'containers/Investigation/AccountInvestigation/epics'
import threatLogEpic from 'containers/Investigation/ThreatLog/epics'

import activitiesEpics from './containers/Activities/epics'
import appEpics from './containers/App/epics'
import awarenessCenterEpics from './containers/AwarenessCenter/epics'
import customizedAutoSyncEpics from './containers/CustomizedAutoSync/epics'
import dashboardEpics from './containers/Dashboard/epics'
import dmarcEpics from './containers/DMARC/epics'
import eulaModalEpic from './containers/EULAModal/epics'
import firstLoginModalepic from './containers/FirstLoginModal/epics'
import globalBannerEpics from './containers/GlobalBanner/epics'
import groupSettingsEpics from './containers/GroupSettings/epics'
import loginEpics from './containers/Login/epics'
import mailboxesEpics from './containers/Mailboxes/epics'
import accountSetupEpics from './containers/Navigation/AccountSetup/epics'
import newReleaseEpics from './containers/NewRelease/epics'
import partnerEpics from './containers/Partner/epics'
import partnerOptionsEpics from './containers/PartnerOptions/epics'
import pollingEpics from './containers/Polling/epics'
import reIntegrationEpics from './containers/Reintegration/epics'
import resolutionCenterEpics from './containers/ResolutionCenter/epics'
import resourcesEpics from './containers/Resources/epics'
import scenarioFormEpic from './containers/ScenarioForm/epics'
import scenarioPreviewEpic from './containers/ScenarioPreview/epics'
import settingsEpics from './containers/Settings/epics'
import shareEpics from './containers/Share/epics'
import shareReportEpics from './containers/ShareReport/epics'
import upgradeModalEpic from './containers/UpgradeLicenseModal/epics'

/**
 * Common epics requests error handler
 *
 * @param {function} func - the relevant action callback
 * @param {object} error - an action error
 * @param {array} expectedErrorCodes - an array of possible status codes, >= 500 are skipped
 */
export const epicsErrorHandler = (func, error, expectedErrorCodes = []) => {
  if (isError(error)) {
    // avoid catching unhandled errors by this function
    throw error
  } else {
    return func({
      title: 'Error',
      detail: extractErrorMessage(error),
      status: error.status,
      response: error.response,
      expectedErrorCodes,
    })
  }
}

export default function createEpics(asyncEpics) {
  return combineEpics(
    accountSetupEpics,
    activitiesEpics,
    appEpics,
    awarenessCenterEpics,
    customizedAutoSyncEpics,
    dashboardEpics,
    dmarcEpics,
    loginEpics,
    mailboxesEpics,
    newReleaseEpics,
    partnerEpics,
    partnerOptionsEpics,
    pollingEpics,
    reIntegrationEpics,
    resolutionCenterEpics,
    resourcesEpics,
    settingsEpics,
    shareEpics,
    shareReportEpics,
    globalBannerEpics,
    groupSettingsEpics,
    upgradeModalEpic,
    scenarioFormEpic,
    threatLogEpic,
    accountInvestigationEpic,
    firstLoginModalepic,
    eulaModalEpic,
    scenarioPreviewEpic
    // ...asyncEpics
  )
}
